// extracted by mini-css-extract-plugin
module.exports = {"single":"Data_single__1DD0a","imgWithBack":"Data_imgWithBack__3Rt2m","num":"Data_num__22n4A","what":"Data_what__3Mb3H"};